import { useState, useEffect } from 'react';
import Loading from '../../../../shared/Loading/Loading';

const PointAndLevel = ({ score, loading, level, numLevels, dateUpdate, getImageUrl, theme = 'light', ranking = null }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let createdUrl = null;

    const loadImage = async () => {
      setImageUrl(null);
      if (level) {
        setImageLoading(true);
        try {
          const themeSuffix = theme === 'dark' ? 'oscuro' : 'claro';
          const themedUrl = await getImageUrl(`${level?.Id} ${themeSuffix}`);
          const fallbackUrl = themedUrl || await getImageUrl(level?.Id);
          createdUrl = fallbackUrl;
          if (!cancelled) setImageUrl(fallbackUrl);
        } finally {
          if (!cancelled) setImageLoading(false);
        }
      } else {
        setImageLoading(false);
      }
    };

    loadImage();

    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [level, getImageUrl, theme]);

  const min = Number(level?.Minimum ?? 0);
  const max = Number(level?.Maximum ?? 0);
  const numericScore = Number(score || 0);
  const progressPercentage =
    max > min
      ? Number(Math.min(Math.max(((numericScore - min) * 100) / (max - min), 0), 100).toFixed(1))
      : 0;
  return (
    <div className="profile-points-section mt-3">
      <div className="profile-points-card rounded-lg border border-gray-200 bg-gray-50 px-3 py-3 shadow-sm">
        <div className="profile-points-summary grid grid-cols-2 items-center gap-x-4 gap-y-2">
          <div className="profile-points-metric flex min-w-0 items-center justify-center gap-0">
            {/* Sin insignia por defecto: solo se muestra la del nivel ya cargado */}
            {!loading && level && numLevels > 0 && !imageLoading && (
              imageUrl ? (
                <img src={imageUrl} alt="Insignia" className="profile-level-image profile-level-badge-image shrink-0 object-contain" />
              ) : (
                <span className="shrink-0 text-2xl font-bold text-gray-500">{level?.NumberLevel}/{numLevels}</span>
              )
            )}

            <div className="min-w-0">
              <p className="whitespace-nowrap text-xs leading-none text-gray-500">Total puntos</p>
              <div className="mt-0.5 flex flex-wrap items-baseline justify-start gap-x-1">
                {loading ? (
                  <div className="flex py-1">
                    <Loading size="5" colorBase="white" colorAccent="personalized" double={true} bold="4" />
                  </div>
                ) : (
                  <span className="text-[1.9rem] font-bold leading-none text-gray-700">{score}</span>
                )}
              </div>
            </div>
          </div>

          {ranking && (
            <div className="profile-points-ranking flex min-w-0 justify-center">
              {ranking}
            </div>
          )}

          <div className="profile-points-progress col-span-2 mt-0 min-w-0 w-full md:-mt-1">
            <div className="mb-1 flex items-center justify-between gap-3">
              <span className="text-xs text-gray-600">Progreso al siguiente nivel</span>
              <span className="text-xs font-medium text-personalized">{progressPercentage}%</span>
            </div>
            <div className="profile-progress-track h-2 w-full rounded-full bg-gray-200">
              <div
                className="h-2 rounded-l-full bg-personalized"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
            <div className="mt-1 flex justify-between text-xs text-gray-500">
              <span>{min} pts</span>
              <span>{max} pts</span>
            </div>
          </div>
        </div>
      </div>

      <div className="profile-score-date mt-2 flex flex-wrap items-center justify-between gap-x-3 gap-y-1 text-xs text-gray-500">
        <span>Ultima actualizacion del puntaje</span>
        <span className="text-right">{dateUpdate || 'Pendiente'}</span>
      </div>
    </div>
  );
};

export default PointAndLevel;
